import { render, staticRenderFns } from "./planGoodsorder.vue?vue&type=template&id=3bcc3378&scoped=true&"
import script from "./planGoodsorder.vue?vue&type=script&lang=js&"
export * from "./planGoodsorder.vue?vue&type=script&lang=js&"
import style0 from "./planGoodsorder.vue?vue&type=style&index=0&id=3bcc3378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc3378",
  null
  
)

export default component.exports